import { HTMLAttributes } from 'react';

import { LinkWithPrevLocation } from '@/components/shared/LinkWithPrevLocation/LinkWithPrevLocation.tsx';
import { appRoutes } from '@/routes/app-routes.ts';
import { useModalStore } from '@/store';

import cn from './styles.module.scss';

export const Checkbox = (props: HTMLAttributes<HTMLInputElement>) => {
    const { setIsAuthHidden, setIsBurgerMenuOpen } = useModalStore();

    const handleClick = () => {
        setIsBurgerMenuOpen(false);
        setIsAuthHidden(true);
    };

    return (
        <label className={cn.container}>
            Нажимая на кнопку, я принимаю{' '}
            <LinkWithPrevLocation
                to={`/${appRoutes.termsOfService}`}
                onClick={handleClick}
                className={cn.link}
                state={{ wasAuthOpen: true }}
            >
                Пользовательское соглашение
            </LinkWithPrevLocation>{' '}
            и подтверждаю, что ознакомлен(-а) с{' '}
            <LinkWithPrevLocation
                to={`/${appRoutes.privacyPolicy}`}
                onClick={handleClick}
                className={cn.link}
                state={{ wasAuthOpen: true }}
            >
                Политикой конфиденциальности
            </LinkWithPrevLocation>
            <input type="checkbox" {...props} />
            <span className={cn.checkmark}></span>
        </label>
    );
};
